<template>
  <div>
    <p>{{ expanded ? text : preview.text }}</p>
    <button v-if="preview.hasQuotedHistory" type="button" class="email-history-toggle" :aria-expanded="expanded" @click="expanded = !expanded">
      {{ expanded ? 'Hide quoted history' : 'Show full email' }}
    </button>
  </div>
</template>
<script>
import { computed, ref } from "vue";
import { emailReplyPreview } from "@/utils/emailReplyPreview.mjs";
export default {
  props: { text: { type: String, default: "" } },
  setup(props) {
    const expanded = ref(false);
    const preview = computed(() => emailReplyPreview(props.text));
    return { expanded, preview };
  }
};
</script>
<style scoped>
p { white-space: pre-wrap; margin: 8px 0; overflow-wrap: anywhere; }
.email-history-toggle { padding: 4px 0; border: 0; background: transparent; color: #286548; text-decoration: underline; font: inherit; font-size: .8rem; cursor: pointer; }
</style>
